import { app } from '../../../../app';

app.component('companySaaspassConnectManage', {
    templateUrl: require('./manage.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/manage.component.js